
import { flexGroupListContext } from 'BrokerTsLib/src/context'
import { useUserFlexGroups } from 'BrokerTsLib/src/hooks/useFlexGroup'

import { TableSection } from '@/components/Section/TableSection'

import { FlexGroupList } from '../flex-group'

export const UserFlexGroups = ({ userId }: { userId: string }) => {

  const { flexGroups, isLoading, refetch } = useUserFlexGroups(userId)

  return (
    <TableSection
      cardHeaderProps={{ py: 2 }}
      sectionTitle="Flexibilní skupiny"
      wide
    >
      <flexGroupListContext.Provider
        value={{
          loading: isLoading,
          totalCount: flexGroups?.length ?? 0,
          currentPage: 1,
          pageSize: 10,
          filter: { showInvalid: false, pageIndex: 1 },
          setCurrentPage: () => { },
          setPageSize: () => { },
          updateFilter: () => { },
          reload: () => refetch(),
        }}
      >
        <FlexGroupList
          flexGroups={flexGroups ?? []}
        />
      </flexGroupListContext.Provider>

    </TableSection>)
}